import { Component, OnInit } from '@angular/core';
import {
    CameraService,
    CesiumEvent,
    CesiumService,
    EditActions,
    MapEventsManagerService,
    MapsManagerService,
    PickOptions,
    PointsEditorService,
    PolygonEditorObservable,
    PolygonEditUpdate,
    PolygonsEditorService,
    RectangleEditorObservable,
    RectangleEditUpdate,
    RectanglesEditorService,
    ZoomToRectangleService,
} from 'angular-cesium';
import { AreaTypeService } from 'src/app/shared/services/area-type.service';
import { FullscreenService } from 'src/app/shared/services/fullscreen.service';
import { GlobeService } from 'src/app/shared/services/globe.service';
import { PopupService } from 'src/app/shared/services/popup.service';

@Component({
    selector: 'app-toolbar-provider',
    templateUrl: './toolbar-provider.component.html',
    styleUrls: ['./toolbar-provider.component.scss'],
    providers: [
        ZoomToRectangleService,
        PointsEditorService,
        PolygonsEditorService,
        RectanglesEditorService,
    ],
})
export class ToolbarProviderComponent implements OnInit {
    polygonEditing$: PolygonEditorObservable;
    rectangleEditing$: RectangleEditorObservable;
    currentRectanglePositions;
    currentPolygonPositions;

    viewer;

    sampleTypeId: number = 1;
    shapeTypeId: number = 1;
    filterValues;

    showBoundaryToggle = true;

    showBoundary = false;
    fullScreen = false;

    drawingRectangle = false;
    drawingPolygon = false;

    toolbarHelpActive = false;

    helpContent;

    constructor(
        private cameraService: CameraService,
        private zoomToRectangleService: ZoomToRectangleService,
        private cesiumService: CesiumService,
        private polygonsEditor: PolygonsEditorService,
        private rectanglesEditor: RectanglesEditorService,
        private mapsManagerService: MapsManagerService,
        private mapEventsManager: MapEventsManagerService,
        private globeService: GlobeService,
        private fullscreenService: FullscreenService,
        private popupService: PopupService,
        private areaTypeService: AreaTypeService
    ) {
        this.cameraService.enableZoom(true);
        this.zoomToRectangleService.init(cesiumService, cameraService);
        this.globeService.getfilterValue().subscribe((filterValues) => {
            if (filterValues) {
                this.sampleTypeId = filterValues.sampleTypeId;
                this.shapeTypeId = filterValues.shapeTypeId;
                this.filterValues = filterValues;
            }
        });

        this.popupService.getPopupStatus().subscribe((data) => {
            if (data == 'reset') {
                this.removeAll();
            }
        });

        this.areaTypeService.getBoundaryStatus().subscribe((data) => {
            this.showBoundary = data.showBoundaryStatus;
        });

        // this.areaTypeService.getDataSourceStatus().subscribe((data) => {
        //   setTimeout(() => {
        //     this.showBoundaryToggle = data;
        //   }, 5000);
        // });

        this.helpContent = {
            fullScreen: 'Toggle full screen mode',
            home: 'Reset view',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out',
            areaType: 'Show/hide area boundaries',
            drawRectangle:
                "Draw a rectangle to select and download data. To draw a rectangle, click the start and end points of the rectangle. See 'Help' for more details.",
            drawPolygon:
                "Draw a free-form polygon to select and download data. To draw a free-form polygon, click each corner of the polygon, and double click to complete. See 'Help' for more details.",
            removeAll: 'Erase drawn rectangle / polygon',
        };
    }

    ngOnInit() {
        this.viewer = this.mapsManagerService.getMap().getCesiumViewer();
        const that = this;
        const clickObservable = this.mapEventsManager.register({
            //entityType: AcEntity, //optional
            event: CesiumEvent.LEFT_CLICK,
            pick: PickOptions.PICK_FIRST,
            priority: 2,
        });

        clickObservable.subscribe((event) => {
            const track = event.entities !== null ? event.entities[0] : null;

            if (!track || !event.entities[0].positions) {
                that.globeService.sendPolygonSelectionInfo({
                    id: 0,
                    position: Cesium.Cartesian3.fromDegrees(0, 0),
                    data: null,
                    show: false,
                });
            }
        });
    }

    toggleFullScreen() {
        this.fullScreen = !this.fullScreen;
        this.fullscreenService.setFullScreenStatus(this.fullScreen);
    }

    toggleBoundary() {
        if (this.showBoundaryToggle) {
            this.showBoundary = !this.showBoundary;
            this.areaTypeService.setBoundaryStatus({
                showBoundaryStatus: this.showBoundary,
                shapeTypeId: this.shapeTypeId,
            });
        }
    }

    zoomToRectangle() {
        this.zoomToRectangleService.activate();
    }

    goHome() {
        this.cameraService.cameraFlyTo({
            destination: Cesium.Cartesian3.fromDegrees(0, 0, 20000000),
        });
    }

    zoomIn() {
        var magnitude = this.cameraService.getCamera().getMagnitude();

        if (this.cameraService.getCamera().getMagnitude() - 4000000 > 8500000) {
            //console.log(this.cameraService.getCamera().getMagnitude());
            this.cameraService.getCamera().zoomIn(4000000);
        }
        if (
            this.cameraService.getCamera().getMagnitude() <= 11000000 &&
            this.cameraService.getCamera().getMagnitude() > 6380000
        ) {
            this.cameraService.getCamera().zoomIn(50000);
            //console.log(this.cameraService.getCamera().getMagnitude());
        }
    }

    zoomOut() {
        if (
            this.cameraService.getCamera().getMagnitude() + 2000000 <
            22378137
        ) {
            this.cameraService.getCamera().zoomOut(500000);
        }
    }

    toggleHelp() {
        this.toolbarHelpActive = !this.toolbarHelpActive;
    }

    drawPolygon() {

        this.removeAll();
        this.drawingPolygon = true;
        // create accepts PolygonEditOptions object
        this.polygonEditing$ = this.polygonsEditor.create({
            allowDrag: false,
        });
        this.polygonEditing$.subscribe((editUpdate: PolygonEditUpdate) => {
            this.globeService.sendPointInfo({
                id: 0,
                position: Cesium.Cartesian3.fromDegrees(0, 0),
                data: null,
                show: false,
            });



            if (
                editUpdate.editAction === EditActions.ADD_LAST_POINT ||
                editUpdate.editAction === EditActions.DRAG_POINT_FINISH
            ) {

                //debugger;
                // console.log(editUpdate.points); // point = position with id
                // console.log(editUpdate.positions); // or just position
                // console.log(editUpdate.updatedPosition); // added position

                console.log(editUpdate.positions)

                if (editUpdate.positions.length > 2) {
                    let geometryInfo = this.getGeometryInfo(
                        editUpdate.positions,
                        'polygon'
                    );

                    let lastPosition =
                        editUpdate.positions[editUpdate.positions.length - 1];

                    console.log(geometryInfo);
                    this.showPopup(2, geometryInfo, lastPosition);
                }
            }
        });
    }

    drawRectangle() {
        this.removeAll();
        this.drawingRectangle = true;
        // create accepts PolygonEditOptions object
        this.rectangleEditing$ = this.rectanglesEditor.create({
            allowDrag: false,
        });
        this.rectangleEditing$.subscribe((editUpdate: RectangleEditUpdate) => {
            this.globeService.sendPointInfo({
                id: 0,
                position: Cesium.Cartesian3.fromDegrees(0, 0),
                data: null,
                show: false,
            });

            if (
                (editUpdate.editAction === EditActions.ADD_POINT &&
                    editUpdate.positions[0].x != editUpdate.positions[1].x &&
                    editUpdate.positions[0].y != editUpdate.positions[1].y) ||
                editUpdate.editAction === EditActions.DRAG_POINT_FINISH
            ) {
                let geometryInfo = this.getGeometryInfo(
                    editUpdate.positions,
                    'rectangle'
                );
                let lastPosition =
                    editUpdate.positions[editUpdate.positions.length - 1];

                this.showPopup(2, geometryInfo, lastPosition);
            }

            // if (editUpdate.positions) {
            //   this.currentRectanglePositions = editUpdate.positions;

            //   let rectangle = this.getRectangle(this.currentRectanglePositions[0], this.currentRectanglePositions[1]);
            //   let centerRectangle = this.getCenter(rectangle);

            //   console.log(rectangle);
            //   console.log(centerRectangle);

            //   let pickedObjects = this.viewer.scene.pick(centerRectangle, rectangle.width, rectangle.height);

            //   console.log(pickedObjects);
            // }
        });
    }

    removePolygon() {
        if (this.polygonEditing$) {
            this.polygonEditing$.dispose();
            this.polygonEditing$ = undefined;
        }
    }

    removeRectangle() {
        if (this.rectangleEditing$) {
            this.rectangleEditing$.dispose();
            this.rectangleEditing$ = undefined;
        }
    }

    removeAll() {
        if (this.polygonEditing$) {
            this.removePolygon();
        }

        if (this.rectangleEditing$) {
            this.removeRectangle();
        }
        this.drawingRectangle = false;
        this.drawingPolygon = false;

        this.globeService.sendPointInfo({
            id: 0,
            position: Cesium.Cartesian3.fromDegrees(0, 0),
            data: null,
            show: false,
        });

        this.globeService.sendPolygonSelectionInfo({
            id: 0,
            position: Cesium.Cartesian3.fromDegrees(0, 0),
            data: null,
            show: false,
        });

        this.drawingPolygon = false;
        this.drawingRectangle = false;
    }

    getRectangle(start, end) {
        var xMin = Math.min(start.x, end.x);
        var xMax = Math.max(start.x, end.x);
        var yMin = Math.min(start.y, end.y);
        var yMax = Math.max(start.y, end.y);

        var width = xMax - xMin;
        var height = yMax - yMin;

        if (xMax <= 0 && xMin <= 0) {
        }

        return new Cesium.BoundingRectangle(xMin, yMin, width, height);
    }

    getCenter(rectangle) {
        return new Cesium.Cartesian2(
            rectangle.x + rectangle.width / 2.0,
            rectangle.y + rectangle.height / 2.0
        );
    }

    getGeometryInfo(positions: any, type: string) {
        let latLonArray = [];
        let pointArray = [];
        let result = {
            positions: [],
            GeoSpatialString: '',
        };
        positions.forEach((pos, idx) => {
            var ellipsoid = this.viewer.scene.globe.ellipsoid;
            var cartographic = ellipsoid.cartesianToCartographic(pos);
            var lat = parseFloat(
                Cesium.Math.toDegrees(cartographic.latitude).toFixed(4)
            );
            var lon = parseFloat(
                Cesium.Math.toDegrees(cartographic.longitude).toFixed(4)
            );
            let coord = {
                lat: lat,
                lon: lon,
            };
            pointArray.push(lon + ' ' + lat);
            latLonArray.push(coord);
        });

        result.positions = latLonArray;

        if (type == 'rectangle') {
            let minX = result.positions[0].lon;
            let minY = result.positions[0].lat;
            let maxX = result.positions[1].lon;
            let maxY = result.positions[1].lat;
            result.GeoSpatialString =
                'POLYGON((' +
                minX +
                ' ' +
                minY +
                ', ' +
                maxX +
                ' ' +
                minY +
                ', ' +
                maxX +
                ' ' +
                maxY +
                ', ' +
                minX +
                ' ' +
                maxY +
                ', ' +
                minX +
                ' ' +
                minY +
                '))';
        } else {
            let startPoint = pointArray[0];
            pointArray.push(startPoint); //we should close the ring with the same start point in the end
            result.GeoSpatialString =
                'POLYGON((' + pointArray.join(', ') + '))';
        }

        return result;
    }

    showPopup(geometryType: number, geometryInfo: any, lastPosition: any) {
        var filterOptions = {
            filterValues: this.filterValues,
            GeoTypeId: geometryType,
            GeoSpatialString: geometryInfo.GeoSpatialString,
        };

        var data = {
            sampleCount: 0,
            measureCount: 0,
            geometryInfo: geometryInfo,
            filterOptions: filterOptions,
        };

//        debugger;

        this.globeService
            .getGeographySampleDataSummary(filterOptions)
            .subscribe((result) => {
                data.sampleCount = result.sampleCount;
                data.measureCount = result.measureCount;

                this.globeService.sendPolygonSelectionInfo({
                    id: 1,
                    position: lastPosition,
                    data: data,
                    show: true,
                });
            });
    }
}
